import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient) { }

  private apiUrl = environment.apiUrl;

  getOrders(filters: any) {
    let params = new HttpParams();

    Object.keys(filters).forEach(key => {
      const value = filters[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value);
      }
    });

    return this.http.get(`${this.apiUrl}/orders/filter`, { params });
  }

  createOrder(data: any) {
    return this.http.post(`${this.apiUrl}/orders`, data);
  }

  getOrdersById(orderId: string) {
    return this.http.get(`${this.apiUrl}/orders/${orderId}`)
  }
  getOrderStatics(customerId: string) {
    return this.http.get(`${this.apiUrl}/orders/customer/${customerId}/stats`)
  }

  getCustomerOrders(customerId: string) {
    return this.http.get(`${this.apiUrl}/orders/customer/${customerId}`)
  }

  completeOrder(payload: any, orderId: string) {
    return this.http.patch(`${this.apiUrl}/orders/${orderId}/complete`, payload)
  }

  cancelOrder(orderId: string) {
    return this.http.patch(`${this.apiUrl}/orders/${orderId}/cancel`, {})
  }

}
